module.exports = __webpack_public_path__ + "static/media/img134_R.684c8885.jpg";